import React from "react";
import "../../styles/Footer.modules.css";

export default function Footer() {
  return (
    <footer>
      <nav>
        <div className="new-links-container">
          <ul className="nav-links">
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#experience">Experience</a>
            </li>
            <li>
              <a href="#projects">Projects</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </nav>
      <p>Copyright &#169; Samvit Jatia</p>
    </footer>
  );
}
